import React from 'react';

interface PlaceholderModuleProps {
  icon: React.ComponentType<any>;
  title: string;
}

export const PlaceholderModule: React.FC<PlaceholderModuleProps> = ({ icon: Icon, title }) => (
  <div className="text-center py-12">
    <Icon size={48} className="mx-auto text-gray-400 mb-4" />
    <h2 className="text-xl font-semibold text-gray-700 mb-2">{title}</h2>
    <p className="text-gray-500">Denne modulen er klar for implementering</p>
  </div>
);
